"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { action, computed, observable, reaction } from "mobx";
export default class CarouselControllerStore {
  constructor(_tileProvider, tileAspectRatio, extraSidePadding, _allowManualScrolling) {
    this._tileProvider = _tileProvider;
    this.tileAspectRatio = tileAspectRatio;
    this._allowManualScrolling = _allowManualScrolling;
    this._componentWidth = 0;
    this._componentHeight = 0;
    this._extraSidePadding = 0;
    this._currentScrollPosition = 0;
    this._isProgrammaticallyScrolling = false;
    this.attemptScrollTarget = 0;
    this._extraSidePadding = extraSidePadding;
    reaction(
      () => this.totalWidth,
      () => {
        this.maybeAllowProgrammaticScroll();
      }
    );
  }
  get componentWidth() {
    return this._componentWidth;
  }
  get componentHeight() {
    return this._componentHeight;
  }
  get extraSidePadding() {
    return this._extraSidePadding;
  }
  get currentScrollPosition() {
    return this._currentScrollPosition;
  }
  get isProgrammaticallyScrolling() {
    return this._isProgrammaticallyScrolling;
  }
  get tileProvider() {
    return this._tileProvider;
  }
  get allowManualScrolling() {
    return this._allowManualScrolling;
  }
  setExtraSidePadding(padding) {
    this._extraSidePadding = padding;
  }
  scrollPage(pagesToScroll) {
    if (!this._isProgrammaticallyScrolling) {
      const amountToScroll = pagesToScroll * this.componentWidth;
      const attemptScrollTarget = this.currentScrollPosition + amountToScroll;
      this.setSmoothScrollTarget(attemptScrollTarget);
    }
  }
  centerTile(index) {
    const t = this.tileWidth;
    const scrollLeft = index * t + this.extraSidePadding;
    const centerOffset = t / 2 - this.componentWidth / 2;
    const attemptScrollTarget = scrollLeft + centerOffset;
    this.setSmoothScrollTarget(attemptScrollTarget);
  }
  resetScroll() {
    this.attemptScrollTarget = 0;
    if (this.scrollCallback) {
      this.scrollCallback(0, true);
    }
    this._isProgrammaticallyScrolling = false;
  }
  get totalWidth() {
    return this.tileWidth * this.tileProvider.contentCount + this.extraSidePadding * 2;
  }
  get tileWidth() {
    return this.componentHeight * this.tileAspectRatio;
  }
  onResize(width, height) {
    this._componentWidth = width || 0;
    this._componentHeight = height || 0;
    this._isProgrammaticallyScrolling = false;
  }
  setScrollPosition(scrollPosition) {
    this._currentScrollPosition = scrollPosition;
    this.maybeAllowProgrammaticScroll();
  }
  registerScrollCallback(scrollFunction) {
    this.scrollCallback = scrollFunction;
  }
  maybeAllowProgrammaticScroll() {
    if (this._isProgrammaticallyScrolling) {
      if (scrollApproxEqual(this.currentScrollPosition, this.clampedScrollTarget)) {
        this._isProgrammaticallyScrolling = false;
      }
    }
  }
  get clampedScrollTarget() {
    const maxScrollTarget = this.totalWidth - this.componentWidth;
    const scrollTarget = Math.min(maxScrollTarget, Math.max(0, this.attemptScrollTarget));
    return scrollTarget;
  }
  setSmoothScrollTarget(attemptScrollTarget) {
    this.attemptScrollTarget = attemptScrollTarget;
    if (!scrollApproxEqual(this.currentScrollPosition, this.clampedScrollTarget)) {
      if (this.scrollCallback) {
        this.scrollCallback(this.clampedScrollTarget);
      }
      this._isProgrammaticallyScrolling = true;
    }
  }
}
__decorateClass([
  observable.ref
], CarouselControllerStore.prototype, "_componentWidth", 2);
__decorateClass([
  observable.ref
], CarouselControllerStore.prototype, "_componentHeight", 2);
__decorateClass([
  observable.ref
], CarouselControllerStore.prototype, "_extraSidePadding", 2);
__decorateClass([
  observable.ref
], CarouselControllerStore.prototype, "_currentScrollPosition", 2);
__decorateClass([
  observable.ref
], CarouselControllerStore.prototype, "_isProgrammaticallyScrolling", 2);
__decorateClass([
  observable.ref
], CarouselControllerStore.prototype, "attemptScrollTarget", 2);
__decorateClass([
  computed
], CarouselControllerStore.prototype, "componentWidth", 1);
__decorateClass([
  computed
], CarouselControllerStore.prototype, "componentHeight", 1);
__decorateClass([
  computed
], CarouselControllerStore.prototype, "extraSidePadding", 1);
__decorateClass([
  computed
], CarouselControllerStore.prototype, "currentScrollPosition", 1);
__decorateClass([
  computed
], CarouselControllerStore.prototype, "isProgrammaticallyScrolling", 1);
__decorateClass([
  action
], CarouselControllerStore.prototype, "setExtraSidePadding", 1);
__decorateClass([
  action
], CarouselControllerStore.prototype, "scrollPage", 1);
__decorateClass([
  action
], CarouselControllerStore.prototype, "centerTile", 1);
__decorateClass([
  action
], CarouselControllerStore.prototype, "resetScroll", 1);
__decorateClass([
  computed
], CarouselControllerStore.prototype, "totalWidth", 1);
__decorateClass([
  computed
], CarouselControllerStore.prototype, "tileWidth", 1);
__decorateClass([
  action.bound
], CarouselControllerStore.prototype, "onResize", 1);
__decorateClass([
  action.bound
], CarouselControllerStore.prototype, "setScrollPosition", 1);
__decorateClass([
  action
], CarouselControllerStore.prototype, "maybeAllowProgrammaticScroll", 1);
__decorateClass([
  computed
], CarouselControllerStore.prototype, "clampedScrollTarget", 1);
const scrollApproxEqual = (n, m) => {
  const SCROLL_EPSILON = 2;
  return Math.abs(n - m) < SCROLL_EPSILON;
};
